<template>
  <div>
    <section v-if="loading">
      <div class="loader"></div>
    </section>
    <section v-else>
      <div v-if="datatableId==='currentOutages' && tableType !== 'suspended'" class="row group-section mb-1">
        <template>
          <div class="col-md-4 lh-3">
            <template>
              Down: <span class="badge badge-danger mr-2">{{totalDownTests}}</span>
              Paused: <span class="badge badge-warning mr-2">{{totalPausedTests}}</span>
              Pending: <span class="badge badge-default mr-2">{{totalPendingTests}}</span>
              Suspended: <span class="badge badge-info mr-2">{{totalSuspendedTests}}</span>
              Total: <span class="badge badge-success"> {{tests.length}}</span>
            </template>
          </div>
          <div class="col-md-4 lh-3 text-center">
            Affected Nodes:
            <button @click="openAffectedNodesAndRacksModal('node')" class="btn btn-primary btn-sm mr-3 text-right" title="View nodes" ><i class="fa fa-eye"></i></button>

          </div>
          <div class="col-md-4 lh-3 text-right">
            Affected Racks:
            <button @click="openAffectedNodesAndRacksModal('rack')" class="btn btn-primary btn-sm mr-3 text-right" title="View racks" ><i class="fa fa-eye"></i></button>

          </div>


        </template>
      </div>
      <div v-if="tableType === 'suspended'" class="row group-section mb-1" v-for="group in getSuspendedGroup" :key="group.planName">
        <template>
          <div class="col-md-1">
            <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }" @click="renderDatatable(group, 'openedGroups')"></span>
          </div>
          <div class="col-md-7 lh-3">
            <b>
              <span>{{group.planName==='Suspended' ? 'Suspended' : group.planName }}</span>
            </b>
<!--            <span class="ml-1" v-if="group.planName !== '(N/A)'">-->
<!--						Server IP:-->
<!--            <b>{{group.serverIp}}</b>-->
<!--            </span>-->
          </div>
          <div class="col-md-4 text-right lh-3">
            <template v-if="status === 'Down'">
              <span title="Down" class="badge badge-danger mr-2 cursor-pointer">{{group.downCount}}</span>
              <span title="Paused" class="badge badge-warning mr-2 cursor-pointer">{{group.pauseCount}}</span>
              <span title="Total" class="badge badge-success cursor-pointer"> {{group.tests.length}}</span>
            </template>
            <template v-else>
              <span title="Total Recent Outages" class="badge badge-success cursor-pointer"> {{group.tests.length}}</span>

              <!--              Total Recent Outages: <b>{{group.tests.length}}</b>-->
            </template>
            <!--						<button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>-->
            <!--						<router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>-->
          </div>
          <div class="col-md-12" v-show="group.showTests">
            <table :id="group.planName==='Suspended' ? `${datatableId}-suspended` : `${datatableId}-${group.planName.split('.')[0]}`" class="table table-striped single-outage-table table-responsive">
              <thead>
              <tr class="text-center">
                <th></th>
                <!--								<th>Test ID</th>-->
                <th>Status</th>
                <th>Tags</th>
                <th>Test Name</th>
                <th>Server IP</th>
                <th>Down Time</th>
                <th>Out ages</th>
                <!--								<th>Status Code</th>-->
                <!--								<th>Uptime</th>-->
                <th width="11%">Note</th>
                <th>Ticket</th>
                <th>Node</th>
                <th>Rack</th>
                <th>Test</th>
                <th width="7%">Acknowledge</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="test in group.tests" :key="test.id" :data-id="test.id">
                <td width="1%">
                  <div class="dropdown m-auto">
                    <button  style="width: 15px!important; padding: 0!important;" title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-cog"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="remove(test, group)">Delete</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login User</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click="openTicketModal(test)">Create Ticket</a>
                      <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }">Edit User</router-link>

                    </div>
                  </div>
                </td>
                <td width="1%" class="text-center">
                  <div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'down', 'up': test.status === 'up', 'pause': test.status === 'paused', 'pending': test.status === 'pending'}"></div>
                </td>
                <td>

                </td>
                <td width="20%" class="text-center domain">
                  <div>
                    <a :href="getEffectiveUrl(test)" target="_blank">
                      {{showDomainName(test.url)}}
                      <!--                      {{// test.url.includes('https://') ? test.url.split('https://')[1] : test.url}}-->
                    </a>
                    <span v-if="checkActiveJob(test)" class="cursor-pointer" :title="getActiveJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'jobTitle'" data-html="true"  >⚠️</span>
                    <span v-if="checkPhpJob(test)" class="cursor-pointer" :title="getPhpJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'jobTitle'" data-html="true"  >
                      <img src="../../../assets/img/php-job.png" height="25">
                    </span>
                    <span v-if="checkCompletedJob(test)" class="cursor-pointer" :title="getCompletedJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'completeJob'" data-html="true"  >⚠️<i class="fa fa-check text-success"></i></span>
                  </div>
                </td>
                <td width="3%" class="text-center" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                <template v-if="status === 'up'">
                  <td width="3%"  class="text-center">
                    {{timeDifferenceBetweenGivenDates(test.incidents[test.incidents.length-1].start, test.incidents[test.incidents.length-2].start)}}
                  </td>
                </template>
                <template v-else>
                  <td width="3%"  class="text-center">
                    {{domainDateTime[test.url]}}
                  </td>
                </template>
                <td width="1%" class="text-center">{{test.downCount}}</td>
                <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                <!--								<td class="text-center">{{test.upTime}}</td>-->
                <td width="13%" class="cursor-pointer domain" @click="openModal(test, 'addNoteModal')" data-toggle="tooltip" data-placement="top" :key="test.id+'addNoteModal'" data-html="true" :title="test.note">{{(test.note && test.note !== '') ? test.note : 'N/A'}}</td>
                <td width="3%" class="text-center">
                  <i @click="openModal(test, 'addTicketModal')" title="Edit ticket" data-toggle="tooltip" data-placement="top" :key="test.id+'editTicket1'" data-html="true"  class="text-primary fa fa-pencil cursor-pointer"></i>
                  <a v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                    <i  title="View Ticket" :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                  </a>
                </td>
                <td width="3%" class="text-center">{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>
                <td width="2%" class="text-center">{{ (allNodes[`${test.nodeId}`]) ? getRackName(allNodes[`${test.nodeId}`].rack_name) || '' : ''}}</td>
                <td width="10%">
                  <select :key="test.id" style="height: 31px; min-width: 70px; max-width: 190px" class="form-control" @change="updateStatusCakeValue(test, $event)">
                    <option></option>
                    <option :selected="(test.statusCake === undefined && (test.status === 'up' || test.status === 'down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>
                    <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>
                    <option :selected="(test.statusCake === undefined && test.status === 'paused ') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>
                    <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>
                    <option :selected="test.statusCake === 'Other'" value="Other">Other</option>
                  </select>
                </td>
                <td width="2%">
                  <template v-if="(test.acknowledgedBy)">
                    <span class="badge badge-pill badge-success">
												{{ (test.acknowledgedBy) }}
											</span>
                  </template>
                  <button @click="acknowledge(test)" v-else-if="test.status === 'down'" :disabled="selectedMonitorLoading && selectedMonitorLoading === test.id" type="button" class="btn btn-primary btn-sm">
                     <span v-if="selectedMonitorLoading && selectedMonitorLoading === test.id">
                      <div class="loader mini_loader"></div>
                    </span>
                    <span v-else>
                      Check In
                    </span>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <div class="customer-list-info col-md-12" v-if="getSuspendedGroup.length === 0">
          <div class="card-text text-center text-danger mb-3 font-weight-bold">
            No Suspended Outages Exists!
          </div>
        </div>
      </div>
      <div v-if="tableType !== 'suspended'" class="row group-section mb-1" v-for="group in getNonWPOGroup" :key="group.planName">
        <template>
          <div class="col-md-1">
            <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }" @click="renderDatatable(group, 'openedGroups')"></span>
          </div>
          <div class="col-md-7 lh-3">
            <b>
              <span>{{group.planName==='(N/A)' ? 'Not in WPO' : group.planName }}</span>
            </b>
            <span class="ml-1" v-if="group.planName !== '(N/A)'">
          Server IP:
          <b>{{group.serverIp}}</b>
          </span>
          </div>
          <!--					<div class="col-md-4 text-center lh-3">-->
          <!--						<template  v-if="status === 'Down'">-->
          <!--							Down: <span class="badge badge-danger mr-3">{{group.downCount}}</span>-->
          <!--							Paused: <span class="badge badge-warning mr-3">{{group.pauseCount}}</span>-->
          <!--							Total: <span class="badge badge-success"> {{group.tests.length}}</span>-->
          <!--						</template>-->
          <!--						<template v-else>-->
          <!--							Total Recent Outages: <b>{{group.tests.length}}</b>-->
          <!--						</template>-->
          <!--					</div>-->
          <div class="col-md-4 text-right lh-3">
            <template  v-if="status === 'Down'">
              <span title="Down" class="badge badge-danger mr-2 cursor-pointer">{{group.downCount}}</span>
              <span title="Paused" class="badge badge-warning mr-2 cursor-pointer">{{group.pauseCount}}</span>
              <span title="Total" class="badge badge-success cursor-pointer"> {{group.tests.length}}</span>
            </template>
            <template v-else>
              <span title="Total Recent Outages" class="badge badge-success cursor-pointer"> {{group.tests.length}}</span>

              <!--              Total Recent Outages: <b>{{group.tests.length}}</b>-->
            </template>
            <!--						<button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>-->
            <!--						<router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>-->
          </div>
          <div class="col-md-12" v-show="group.showTests">
            <table :id="group.planName==='(N/A)' ? `${datatableId}-unavailable` : `${datatableId}-${group.planName.split('.')[0]}`" class="table table-striped single-outage-table table-responsive">
              <thead>
              <tr class="text-center">
                <th></th>
                <!--								<th>Test ID</th>-->
                <th>Status</th>
                <th>Tags</th>
                <th>Test Name</th>
                <th>Server IP</th>
                <th>Down Time</th>
                <th>Out ages</th>
                <!--								<th>Status Code</th>-->
                <!--								<th>Uptime</th>-->
                <th width="11%">Note</th>
                <th>Ticket</th>
                <th>Node</th>
                <th>Rack</th>
                <th>Test</th>
                <th width="7%">Acknowledge</th>

                <!--								<th width="12%">Action</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="test in group.tests" :key="test.id" :data-id="test.id">
                <td width="1%">
                  <div class="dropdown m-auto">
                    <button  style="width: 15px!important; padding: 0!important;" title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  >
                      <i class="fa fa-cog"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="remove(test, group)">Delete</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" findUser(group)">Login User</a>
                      <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" openTicketModal(test)">Create Ticket</a>
                      <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }">Edit User</router-link>

                    </div>
                  </div>
                </td>
                <!--								<td width="3%">-->
                <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>-->
                <!--								</td>-->
                <!--								<td class="text-center">{{ test.testId }}</td>-->
                <td width="1%" class="text-center">
                  <div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'down', 'up': test.status === 'up', 'pause': test.status === 'paused', 'pending': test.status === 'pending'}"></div>
                </td>
                <td>

                </td>
                <td width="20%" class="text-center domain">
                  <div>
                    <a :href="getEffectiveUrl(test)" target="_blank">
                      {{showDomainName(test.url)}}
                      <!--                      {{// test.url.includes('https://') ? test.url.split('https://')[1] : test.url}}-->
                    </a>
                    <span v-if="checkActiveJob(test)" class="cursor-pointer" :title="getActiveJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test.url+'jobTitle'" data-html="true"  >⚠️</span>
                    <span v-if="checkPhpJob(test)" class="cursor-pointer" :title="getPhpJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'jobTitle'" data-html="true"  >
                      <img src="../../../assets/img/php-job.png" height="25">
                    </span>
                    <span v-if="checkCompletedJob(test)" class="cursor-pointer" :title="getCompletedJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'completeJob'" data-html="true"  >⚠️<i class="fa fa-check text-success"></i></span>
                  </div>
                </td>
                <td width="3%" class="text-center" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                <template v-if="status === 'up'">
                  <td width="3%"  class="text-center">
                    {{timeDifferenceBetweenGivenDates(test.incidents[test.incidents.length-1].start, test.incidents[test.incidents.length-2].start)}}
                  </td>
                </template>
                <template v-else>
                  <td width="3%"  class="text-center">
                    {{domainDateTime[test.url]}}
                  </td>
                </template>
                <td width="1%" class="text-center">{{test.downCount}}</td>
                <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                <!--								<td class="text-center">{{test.upTime}}</td>-->
                <td width="13%" class="cursor-pointer domain" @click="openModal(test, 'addNoteModal')" :title="test.note">{{(test.note && test.note !== '') ? test.note : 'N/A'}}</td>
                <td width="3%" class="text-center">
                  <i @click="openModal(test, 'addTicketModal')" title="Edit ticket" class="text-primary fa fa-pencil cursor-pointer" ></i>
                  <a v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                    <i  title="View Ticket" :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                  </a>
                </td>
                <td width="3%" class="text-center">{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>
                <td width="2%" class="text-center">{{ (allNodes[`${test.nodeId}`]) ? getRackName(allNodes[`${test.nodeId}`].rack_name) || '' : ''}}</td>
                <td width="10%">
                  <select :key="test.id" style="height: 31px; min-width: 70px; max-width: 190px" class="form-control" @change="updateStatusCakeValue(test, $event)">
                    <!--                    <option></option>-->
                    <option :value="row.status" :selected="checkStatusCake(test, row.status)" v-for="(row, index) in statusList" :key="index">
                      {{row.status}}
                    </option>
                    <!--                    <option :selected="(test.statusCake === undefined && (test.status === 'up' || test.status === 'down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
                    <!--                    <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
                    <!--                    <option :selected="(test.statusCake === undefined && test.status === 'paused ') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
                    <!--                    <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
                    <!--                    <option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
                  </select>
                </td>
                <td width="2%">
                  <template v-if="test.acknowledgedBy">
                  <span class="badge badge-pill badge-success">
                      {{ (test.acknowledgedBy) }}
                    </span>
                  </template>
                  <button @click="acknowledge(test)" v-else-if="test.status === 'down'" :disabled="selectedMonitorLoading && selectedMonitorLoading === test.id" type="button" class="btn btn-primary btn-sm">
                  <span v-if="selectedMonitorLoading && selectedMonitorLoading === test.id">
                    <div class="loader mini_loader"></div>
                  </span>
                    <span v-else>
                    Check In
                  </span>
                  </button>
                </td>
                <!--								<td width="12%" class="text-center">-->
                <!--									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">-->
                <!--										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>-->
                <!--										<i v-else class="fa fa-pause"></i>-->
                <!--									</button>-->
                <!--									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">-->
                <!--										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>-->
                <!--										<i v-else class="fa fa-trash"></i>-->
                <!--									</button>-->
                <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'addNoteModal')">-->
                <!--										<i class="fa fa-file-text-o"></i>-->
                <!--									</button>-->
                <!--								</td>-->
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <!--				<template v-else>-->
        <!--					<div class="col-md-12">-->
        <!--						<table class="table table-striped single-outage-table">-->
        <!--							<thead>-->
        <!--								<tr class="text-center">-->
        <!--									<th ></th>-->
        <!--									<th>Test ID</th>-->
        <!--									<th>Status</th>-->
        <!--									<th>Test Name</th>-->
        <!--									<th>Server IP</th>-->
        <!--									<th>Downtime</th>-->
        <!--									<th>Primary Domain</th>-->
        <!--									<th>Outages</th>-->
        <!--&lt;!&ndash;									<th>Status Code</th>&ndash;&gt;-->
        <!--&lt;!&ndash;									<th>Uptime</th>&ndash;&gt;-->
        <!--									<th width="11%">Note</th>-->
        <!--                  <th>Node</th>-->
        <!--                  <th>Rack</th>-->
        <!--									<th>Test</th>-->
        <!--&lt;!&ndash;									<th width="12%">Action</th>&ndash;&gt;-->
        <!--								</tr>-->
        <!--							</thead>-->
        <!--							<tbody>-->
        <!--								<tr v-for="test in group.tests" :key="test.testId" :data-id="test.testId">-->
        <!--                  <td >-->
        <!--                    <div class="dropdown">-->
        <!--                      <button title="Choose Operation" class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
        <!--                        <i class="fa fa-cog"></i>-->
        <!--                      </button>-->
        <!--                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login User</a>-->
        <!--                        <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid } }">Edit User</router-link>-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test)">Delete</a>-->
        <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>-->

        <!--                       </div>-->
        <!--                    </div>-->
        <!--                  </td>-->
        <!--&lt;!&ndash;								<td width="10%">&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-1" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-primary btn-sm mr-1" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<router-link v-if="group.uid" class="btn btn-primary btn-sm"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>&ndash;&gt;-->
        <!--&lt;!&ndash;								</td>&ndash;&gt;-->
        <!--								<td class="text-center">{{ test.testId }}</td>-->
        <!--								<td class="text-center">-->
        <!--									<div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'Down', 'up': test.status === 'Up', 'pause': test.status === 'Paused'}"></div>-->
        <!--								</td>-->
        <!--								<td class="text-center"><a :href="test.URL" target="_blank">{{test.URL}}</a></td>-->
        <!--								<td class="text-center">{{ test.serverIP }}</td>-->
        <!--                  <template v-if="status === 'Up'">-->
        <!--									<td class="text-center">-->
        <!--										{{timeDifferenceBetweenGivenDates(test.events[test.events.length-1].start, test.events[test.events.length-2].start)}}-->
        <!--									</td>-->
        <!--								</template>-->
        <!--								<template v-else>-->
        <!--									<td class="text-center">-->
        <!--										{{domainDateTime[test.URL]}}-->
        <!--									</td>-->
        <!--								</template>-->
        <!--								<td class="text-center">{{group.planName}}</td>-->
        <!--								<td class="text-center">{{test.downCount}}</td>-->
        <!--&lt;!&ndash;								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>&ndash;&gt;-->
        <!--&lt;!&ndash;								<td class="text-center">{{test.upTime}}</td>&ndash;&gt;-->
        <!--								<td width="11%" class="" :title="test.note">{{(test.note && test.note !== '') ? test.note.substring(0, 20) : 'N/A'}}</td>-->
        <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>-->
        <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].rack_name || '' : ''}}</td>-->
        <!--                <td width="13%">-->
        <!--									<select class="form-control" @change="updateStatusCakeValue(test, $event)">-->
        <!--										<option></option>-->
        <!--										<option :selected="(test.statusCake === undefined && (test.status === 'Up' || test.status === 'Down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
        <!--										<option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
        <!--										<option :selected="(test.statusCake === undefined && test.status === 'Paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
        <!--										<option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
        <!--										<option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
        <!--									</select>-->
        <!--								</td>-->
        <!--&lt;!&ndash;								<td width="12%" class="text-center">&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">&ndash;&gt;-->
        <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>&ndash;&gt;-->
        <!--&lt;!&ndash;										<i v-else class="fa fa-pause"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;									</button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">&ndash;&gt;-->
        <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>&ndash;&gt;-->
        <!--&lt;!&ndash;										<i v-else class="fa fa-trash"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;									</button>&ndash;&gt;-->
        <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-3" @click="openModal(test, 'addNoteModal')">&ndash;&gt;-->
        <!--&lt;!&ndash;										<i class="fa fa-file-text-o"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;									</button>&ndash;&gt;-->
        <!--&lt;!&ndash;								</td>&ndash;&gt;-->
        <!--							</tr>-->
        <!--							</tbody>-->
        <!--						</table>-->
        <!--					</div>-->
        <!--				</template>-->
      </div>
      <div  v-if="tableType !== 'suspended'" class="row group-section mb-1 " >
          <template>
            <div class="col-md-10 mt-2">
              <label> Show
                <select class="custom-select custom-select-sm form-control form-control-sm datatable-dropdown" id="grouped"  aria-describedby="grouped" required v-model="pageSize">
                  <option value="10" >10</option>
                  <option value="25" >25</option>
                  <option value="50" >50</option>
                  <option :value="paginatedGroups.length" >All</option>
                </select> entries</label>
            </div>
            <div class="col-md-2 text-right">
              <div class="dropdown m-auto">
                <button  style="width: 20px!important; padding: 0!important;" title="Filter by Tags" class="filter-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-filter fs-20"></i>
                </button>
                <div style="min-width: 8rem;" class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                  <div class="ml-10 mt-3 d-flex align-items-center" v-for="(option, index) in filteredOptions" :key="index">
                    <input @input="checkOption($event)" type="checkbox" v-model="selectedFilters" :value="option">
                    <span class="ml-10" v-if="option.tag === 'all' || option.tag === 'none'">
                      {{option.text}}
                    </span>
                    <img v-else class="ml-10" style="width: 30px !important;" :src="option.src" alt="">
                  </div>
                  <div class="ml-10 mt-3 d-flex align-items-center">
                    <input type="checkbox" v-model="notInWPOFilter" :key="datatableId" :value="notInWPOFilter">
                    <i class="fa fa-ban ml-10 text-danger" title="Not In WPO" style="font-size: 28px"></i>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-12 mt-2">
              <table :id="`${datatableId}-ungrouped`" class="table table-striped single-outage-table table-responsive">
                <thead>
                <tr class="text-center">
                  <th></th>
                  <!--								<th>Test ID</th>-->
                  <th>Status
                    <!--                  <i v-if="!statusSortType || statusSortType==='desc'" class="fa fa-sort-down" :class="statusSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedStatusSort()" />-->
                    <!--                  <i v-if="!statusSortType || statusSortType==='asc'"  class="fa fa-sort-up " :style="!statusSortType?'margin-left:-7px':'' "  :class="statusSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedStatusSort()" />-->

                  </th>
                  <th>Tags</th>
                  <th>Test Name
                    <i v-if="!planSortType || planSortType==='desc'" class="fa fa-sort-down" :class="planSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedPlanSort()" />
                    <i v-if="!planSortType || planSortType==='asc'"  class="fa fa-sort-up " :style="!planSortType?'margin-left:-7px':'' "  :class="planSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedPlanSort()" />
                  </th>
                  <th>Server IP
                    <i v-if="!ipSortType || ipSortType==='desc'" class="fa fa-sort-down" :class="ipSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedIpSort()" />
                    <i v-if="!ipSortType || ipSortType==='asc'"  class="fa fa-sort-up " :style="!ipSortType?'margin-left:-7px':'' "  :class="ipSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedIpSort()" />
                  </th>
                  <th>Cause</th>
                  <th width="7%">Down Time
                    <i v-if="!downtimeType || downtimeType==='desc'" class="fa fa-sort-down" :class="downtimeType==='desc' ? 'text-primary': 'text-muted'" @click="clickedDowntimeSort()" />
                    <i v-if="!downtimeType || downtimeType==='asc'"  class="fa fa-sort-up " :style="!downtimeType?'margin-left:-7px':'' "  :class="downtimeType==='asc' ? 'text-primary': 'text-muted'" @click="clickedDowntimeSort()" />
                  </th>
                  <th>Out ages
                    <i v-if="!outageSortType || outageSortType==='desc'" class="fa fa-sort-down" :class="outageSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedOutageSort()" />
                    <i v-if="!outageSortType || outageSortType==='asc'"  class="fa fa-sort-up " :style="!outageSortType?'margin-left:-7px':'' "  :class="outageSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedOutageSort()" />
                  </th>
                  <!--								<th>Status Code</th>-->
                  <!--								<th>Uptime</th>-->
                  <th width="18%">Note</th>
                  <th>Ticket</th>
                  <th>Node
                    <i v-if="!nodeSortType || nodeSortType==='desc'" class="fa fa-sort-down" :class="nodeSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedNodeSort()" />
                    <i v-if="!nodeSortType || nodeSortType==='asc'"  class="fa fa-sort-up " :style="!nodeSortType?'margin-left:-7px':'' "  :class="nodeSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedNodeSort()" />
                  </th>
                  <th>Rack
                    <i v-if="!rackSortType || rackSortType==='desc'" class="fa fa-sort-down" :class="rackSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedRackSort()" />
                    <i v-if="!rackSortType || rackSortType==='asc'"  class="fa fa-sort-up " :style="!rackSortType?'margin-left:-7px':'' "  :class="rackSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedRackSort()" />
                  </th>
                  <th>Test</th>
                  <th>Acknowledge</th>
                  <!--								<th width="12%">Action</th>-->
                </tr>
                </thead>
                <tbody v-for="(group, index) in getWPOGroup" :key="index">
                <tr v-if="group.tests.length > 1">
                  <td>
                    <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }" @click="renderDatatable(group, 'openedGroups')"></span>
                  </td>
                  <td class="text-center" width="7%">
                    <template  v-if="status === 'Down'">
                      <span title="Down" class="badge badge-danger p-4-4">{{group.downCount}}</span>
                      <span title="Paused" class="badge badge-warning p-4-4">{{group.pauseCount}}</span>
                      <span title="Pending" class="badge badge-default p-4-4">{{group.pendingCount}}</span>
                      <span title="Total" class="badge badge-success p-4-4"> {{group.tests.length}}</span>
                    </template>
                    <template v-else>
                      <span title="Total Recent Outages" class="badge badge-success"> {{group.tests.length}}</span>
                      <!--                    Total Recent Outages: <b>{{group.tests.length}}</b>-->
                    </template>
                  </td>
                  <td></td>
                  <td class="text-center">
                    <div>
                      <b>
                        {{group.planName==='(N/A)' ? 'Not in WPO' : group.planName }}
                      </b>
                    </div>
                  </td>
                  <td> <span class="ml-1" v-if="group.planName !== '(N/A)'">
                      <b>{{group.serverIP}}</b>
                    </span></td>
                  <td></td>
                  <td></td>
                  <td width="5%" class="text-center">{{getTotalOutages(group)}}</td>
                  <td></td>
                  <td></td>
                  <td width="3%" class="text-center">{{ (allNodes[`${group.tests[0].nodeId}`]) ? allNodes[`${group.tests[0].nodeId}`].nodeName || '' : '' }}</td>
                  <td width="7%" class="text-center">{{ (allNodes[`${group.tests[0].nodeId}`]) ? getRackName(allNodes[`${group.tests[0].nodeId}`].rack_name) || '' : ''}}</td>
                  <td></td>
                  <td width="2%">
                    <template v-if="group.acknowledgedByNames.length && !group.showCheckin">
                    <span v-for="(row, index) in group.acknowledgedByNames" :key="index" class="badge badge-pill badge-success">
												{{ row }}
                    </span>
                    </template>
                    <button @click="bulkAcknowledgeV2(group, user.firstName + ' ' + user.lastName)" v-if="status === 'Down' && group.showCheckin && group.downCount > 1" :disabled="selectedPlanLoading && selectedPlanLoading === group.planName" type="button" class="btn btn-primary btn-sm">
                    <span v-if="selectedPlanLoading && selectedPlanLoading === group.planName">
                      <div class="loader mini_loader"></div>
                    </span>
                      <span v-else>
                      Check In
                    </span>
                    </button>
                  </td>
                  <!--                <td class="text-center">-->
                  <!--                  <template  v-if="status === 'down'">-->
                  <!--                  <span title="Down" class="badge badge-danger mr-1">{{group.downCount}}</span>-->
                  <!--                  <span title="Paused" class="badge badge-warning mr-1">{{group.pauseCount}}</span>-->
                  <!--                  <span title="Total" class="badge badge-success"> {{group.tests.length}}</span>-->
                  <!--                </template>-->
                  <!--                  <template v-else>-->
                  <!--                    <span title="Total Recent Outages" class="badge badge-success"> {{group.tests.length}}</span>-->
                  <!--                    &lt;!&ndash;                    Total Recent Outages: <b>{{group.tests.length}}</b>&ndash;&gt;-->
                  <!--                  </template>-->
                  <!--                  &lt;!&ndash;                  <button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>&ndash;&gt;-->
                  <!--                  &lt;!&ndash;                  <router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>&ndash;&gt;-->
                  <!--                </td>-->
                </tr>
                <tr :class="{ 'down-monitor-bg' : group.tests[0].status === 'down' && checkDownTime(group.tests[0]) > 5 }" v-else-if="group.tests.length==1">
                  <td width="1%">
                    <div class="dropdown m-auto">
                      <button  style="width: 15px!important; padding: 0!important;" title="Choose Operation" class="settinds-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cog"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(group.tests[0], 'viewEventsModal')">View Details</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(group.tests[0], group)">Delete</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(group.tests[0], 'addNoteModal')">Add Notes</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login User</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click=" openTicketModal(group.tests[0])">Create Ticket</a>
                        <router-link v-if="group.uid " class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid || group.tests[0].uid } }">Edit User</router-link>

                      </div>
                    </div>
                  </td>
                  <!--								<td width="3%">-->
                  <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>-->
                  <!--								</td>-->
                  <!--                  <td class="text-center">{{ group.tests[0].testId }}</td>-->
                  <td width="1%" class="text-center">
                    <div @click="openModal(group.tests[0], 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': group.tests[0].status === 'down', 'up': group.tests[0].status === 'up', 'pause': group.tests[0].status === 'paused', 'pending': group.tests[0].status === 'pending'}"></div>
                  </td>
                  <td class="text-center" width="5%">
                    <div class="text-center" v-if="group.tests[0].tagCategories && group.tests[0].tagCategories.length>0" :style="`min-width: ${(25 * group.tests[0].tagCategories.length)+5}px;`">
                    <span v-for="(row, index) in group.tests[0].tagCategories" :key="index" class="cursor-pointer">
                      <img v-if="row.tag.toLowerCase() === 'cloudflare'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../assets/img/cloudflare.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/bigscoots_cf.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/bigscoots.jpg" alt="">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/ezoic_cache.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/ezoic_ADS.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/sucuri.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/squarespace.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/nerdpress.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/wix.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/shopify-tag.png" alt="">
                    </span>
                    </div>
                    <i v-if="group.notInWPO" title="Not In WPO" class="fa fa-ban text-danger fs-20 make-cursor-pointer" aria-hidden="true"></i>
                  </td>
                  <td width="20%" class="text-center domain">
                    <div>
                      <a :href="getEffectiveUrl(group.tests[0])" target="_blank">
                        {{showDomainName(group.tests[0].url)}}
                        <!--                     {{group.tests[0].url.includes('https://') ? group.tests[0].url.split('https://')[1].replace('/?v={timestamp}', '') : group.tests[0].url.replace('/?v={timestamp}', '')}}-->
                      </a>
                      <a v-if="group.tests[0].status === 'down' && getScreenshotUrl(group.tests[0])" :href="getScreenshotUrl(group.tests[0])" target="_blank"><img  data-toggle="tooltip" data-placement="top" :key="group.tests[0].url+'screenshot'" data-html="true" title="View Screenshot" class="ml-2 w-8" src="../../../../src/assets/img/screenshot.png" alt=""></a>
                      <a v-if="group.tests[0].status === 'down' && getResponseUrl(group.tests[0])" :href="getResponseUrl(group.tests[0])" target="_blank"><img   data-toggle="tooltip" data-placement="top" :key="group.tests[0].url+'response'" data-html="true" title="View Response Url" class="ml-2 w-6" src="../../../../src/assets/img/browser.png" alt=""  ></a>
                      <span v-if="checkActiveJob(group.tests[0])" class="cursor-pointer" :title="getActiveJobTitle(group.tests[0])" data-toggle="tooltip" data-placement="top" :key="group.tests[0]+'jobTitle'" data-html="true"  >⚠️</span>
                      <span  v-if="checkPhpJob(group.tests[0])" class="cursor-pointer" :title="getPhpJobTitle(group.tests[0])" data-toggle="tooltip" data-placement="top" :key="group.tests[0]+'jobTitle'" data-html="true"  >
                        <img src="../../../assets/img/php-job.png" height="25">
                      </span>
                      <span v-if="checkCompletedJob(group.tests[0])" class="cursor-pointer" :title="getCompletedJobTitle(group.tests[0])" data-toggle="tooltip" data-placement="top" :key="group.tests[0]+'completeJob'" data-html="true"  >⚠️<i class="fa fa-check text-success"></i></span>
                    </div>
                  </td>
                  <td width="3%" @click="doCopy(group.tests[0].serverIP)" class="text-center">
                    {{ group.tests[0].serverIP }}
                  </td>
                  <template v-if="group.tests[0].incidents[group.tests[0].incidents.length - 1].cause">
                    <td width="10%" v-if="group.tests[0].incidents[group.tests[0].incidents.length - 1].cause.length > causeLength" >
                    <span v-if="!getProperty(group.tests[0].id)">
                      {{group.tests[0].incidents[group.tests[0].incidents.length - 1].cause.slice(0,causeLength) }}
                      <a  href="javascript:void(0)"  @click="changeCauseLength(group.tests[0])">more</a>
                    </span>

                      <template v-else>
                        {{group.tests[0].incidents[group.tests[0].incidents.length - 1].cause }}
                        <a  href="javascript:void(0)"  @click="changeCauseLength(group.tests[0])">less</a>
                      </template>
                    </td>

                    <td width="10%" v-else>{{group.tests[0].incidents[group.tests[0].incidents.length - 1].cause   }}</td>
                  </template>
                  <template v-else>
                    <td width="10%">{{group.tests[0].incidents[group.tests[0].incidents.length - 1].cause  }}</td>
                  </template>
                  <template v-if="status === 'up'">
                    <td width="3%" class="text-center">
                      {{timeDifferenceBetweenGivenDates(group.tests[0].incidents[group.tests[0].incidents.length-1].end, group.tests[0].incidents[group.tests[0].incidents.length-1].start)}}
                      <!--                    {{group.tests[0].incidents[group.tests[0].incidents.length-1].start}}-->
                    </td>
                  </template>
                  <template v-else>
                    <td width="3%" class="text-center">
                      {{domainDateTime[group.tests[0].url]}}
                    </td>
                  </template>
                  <td width="3%" class="text-center">{{group.tests[0].downCount}}</td>
                  <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                  <!--								<td class="text-center">{{test.upTime}}</td>-->
                  <td width="18%" class="cursor-pointer domain" @click="openModal(group.tests[0], 'addNoteModal')" :title="getNoteTooltip(group.tests[0])">{{(group.tests[0].note && group.tests[0].note !== '') ? group.tests[0].note: 'N/A'}}</td>
                  <td width="3%" class="text-center">
                    <i @click="openModal(group.tests[0], 'addTicketModal')" data-toggle="tooltip" data-placement="top" :key="group.tests[0].url+'editTicket123'" data-html="true" title="Edit ticket"  class="text-primary fa fa-pencil cursor-pointer"></i>
                    <a v-if="group.tests[0].ticket_url" :href="group.tests[0].ticket_url" target="_blank">
                      <i  title="View Ticket" :class="group.tests[0].ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                    </a>
                  </td>
                  <td width="3%" class="text-center">{{ (allNodes[`${group.tests[0].nodeId}`]) ? allNodes[`${group.tests[0].nodeId}`].nodeName || '' : '' }}</td>
                  <td width="2%" class="text-center">{{ (allNodes[`${group.tests[0].nodeId}`]) ? getRackName(allNodes[`${group.tests[0].nodeId}`].rack_name) || '' : ''}}</td>
                  <td width="10%">
                    <select :key="group.tests[0].id" style="height: 31px; min-width: 70px; max-width: 190px" class="form-control" @change="updateStatusCakeValue(group.tests[0], $event)">
                      <option :value="row.status" :selected="checkStatusCake(group.tests[0], row.status)" v-for="(row, index) in statusList" :key="index">
                        {{row.status}}
                      </option>
                      <!--                    <option :selected="(group.tests[0].statusCake === undefined && (group.tests[0].status === 'up' || group.tests[0].status === 'down')) ? true : group.tests[0].statusCake === 'Active'" value="Active">Active</option>-->
                      <!--                    <option :selected="group.tests[0].statusCake === 'Moved'" value="Moved">Moved</option>-->
                      <!--                    <option :selected="(group.tests[0].statusCake === undefined && group.tests[0].status === 'paused') ? true : group.tests[0].statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
                      <!--                    <option :selected="group.tests[0].statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
                      <!--                    <option :selected="group.tests[0].statusCake === 'Other'" value="Other">Other</option>-->
                    </select>
                  </td>
                  <td width="2%">
                    <template v-if="group.tests[0].acknowledgedBy">
                    <span class="badge badge-pill badge-success">
												{{ group.tests[0].acknowledgedBy }}
											</span>
                    </template>
                    <button @click="bulkAcknowledgeV2(group, user.firstName + ' ' + user.lastName)" v-else-if="group.tests[0].status === 'down'" :disabled="selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id" type="button" class="btn btn-primary btn-sm">
                    <span v-if="selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id">
                      <div class="loader mini_loader"></div>
                    </span>
                      <span v-else>
                      Check In
                    </span>
                    </button>
                  </td>
                </tr>
                <tr :class="test.status === 'down' && checkDownTime(test) > 5 ? 'down-monitor-bg' : 'bg-light'" v-show="group.tests.length > 1 && group.showTests" v-for="test in (group.tests)" :key="test.id" :data-id="test.id">
                  <td width="1%">
                    <div class="dropdown m-auto">
                      <button title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle" style="width: 15px!important; padding: 0!important;" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cog"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test, group)">Delete</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>
                        <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" findUser(group)">Login User</a>
                        <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click="openTicketModal(test)">Create Ticket</a>

                        <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }">Edit User</router-link>

                      </div>
                    </div>
                  </td>

                  <td width="1%" class="text-center">
                    <div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'down', 'up': test.status === 'up', 'pause': test.status === 'paused', 'pending': test.status === 'pending'}"></div>
                  </td>
                  <td class="text-center" width="5%">
                    <div class="text-center" v-if="test.tagCategories && test.tagCategories.length>0" :style="`min-width: ${(25 * test.tagCategories.length)+5}px;`">
                    <span v-for="(row, index) in test.tagCategories" :key="index" class="cursor-pointer" >
                      <img v-if="row.tag.toLowerCase() === 'cloudflare'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../assets/img/cloudflare.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/bigscoots_cf.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/bigscoots.jpg" alt="">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px!important;" src="../../../../src/assets/img/ezoic_cache.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'" :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" class="" style="width: 20px!important;" src="../../../../src/assets/img/ezoic_ADS.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/sucuri.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/squarespace.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/nerdpress.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/wix.png" alt="">
                      <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" class="" style="width: 20px !important;" src="../../../../src/assets/img/shopify-tag.png" alt="">
                  </span>
                  </div>
                </td>
                <td class="text-center domain"  width="20%">
                  <div>
                    <a :href="getEffectiveUrl(test)" target="_blank">
                      {{showDomainName(test.url)}}
                      <!--                      {{ showDomainName(test.url) }}-->
                      <!--                      {{// test.url.includes('https://') ? test.url.split('https://')[1].replace('/?v={timestamp}', '') : test.url.replace('/?v={timestamp}', '')}}-->
                    </a>
                    <a v-if="test.status === 'down' && getScreenshotUrl(test)" :href="getScreenshotUrl(test)" target="_blank"><img  data-toggle="tooltip" data-placement="top" :key="test.url+'screenshot1'" data-html="true" title="View Screenshot"  class="ml-2 w-8" src="../../../../src/assets/img/screenshot.png" alt=""></a>
                    <a v-if="test.status === 'down' && getResponseUrl(test)" :href="getResponseUrl(test)" target="_blank"><img  data-toggle="tooltip" data-placement="top" :key="test.url+'response1'" data-html="true"  title="View Response Url" class="ml-2 w-6" src="../../../../src/assets/img/browser.png" alt=""></a>
                    <span v-if="checkActiveJob(test)" class="cursor-pointer" :title="getActiveJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'jobTitle'" data-html="true"  >⚠️</span>
                    <span v-if="checkPhpJob(test)" class="cursor-pointer" :title="getPhpJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'jobTitle'" data-html="true"  >
                        <img src="../../../assets/img/php-job.png" height="25">
                      </span>
                    <span v-if="checkCompletedJob(test)" class="cursor-pointer" :title="getCompletedJobTitle(test)" data-toggle="tooltip" data-placement="top" :key="test+'completeJob'" data-html="true"  >⚠️<i class="fa fa-check text-success"></i></span>
                  </div>
                </td>
                <td width="3%" class="text-center" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                <template v-if="test.incidents[test.incidents.length - 1].cause">
                  <td width="10%" v-if="test.incidents[test.incidents.length - 1].cause.length > causeLength" >
                  <span v-if="!getProperty(test.id)">
                  {{test.incidents[test.incidents.length - 1].cause.slice(0,causeLength) }}
                  <a  href="javascript:void(0)"  @click="changeCauseLength(test)"> more</a>
                  </span>
                      <template v-else>
                        {{test.incidents[test.incidents.length - 1].cause }}
                        <a  href="javascript:void(0)"  @click="changeCauseLength(test)"> less</a>
                      </template>

                    </td>

                    <td width="10%" v-else>{{test.incidents[test.incidents.length - 1].cause }}</td>
                  </template>
                  <template v-else>
                    <td width="10%">{{test.incidents[test.incidents.length - 1].cause }}</td>
                  </template>


                  <template v-if="status === 'up'">
                    <td width="3%"  class="text-center">
                      {{timeDifferenceBetweenGivenDates(test.incidents[test.incidents.length-1].start, test.incidents[test.incidents.length-2].start)}}
                    </td>
                  </template>
                  <template v-else>
                    <td width="6%"  class="text-center">
                      {{domainDateTime[test.url]}}
                    </td>
                  </template>
                  <td width="3%" class="text-center">{{test.downCount}}</td>
                  <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                  <!--								<td class="text-center">{{test.upTime}}</td>-->
                  <td width="18%" class="cursor-pointer domain" @click="openModal(test, 'addNoteModal')" :title="getNoteTooltip(test)">{{(test.note && test.note !== '') ? test.note : 'N/A'}}</td>
                  <td width="3%" class="text-center">
                    <i @click="openModal(test, 'addTicketModal')" title="Edit ticket"  data-toggle="tooltip" data-placement="top" :key="test.url+'editTicket321'" data-html="true" class="text-primary fa fa-pencil cursor-pointer"></i>
                    <a  v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                      <i title="View Ticket" :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                    </a>
                  </td>
                  <td width="3%" class="text-center">{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>
                  <td width="2%" class="text-center">{{ (allNodes[`${test.nodeId}`]) ? getRackName(allNodes[`${test.nodeId}`].rack_name) || '' : ''}}</td>

                  <td width="3%">
                    <select :key="test.id" style="height: 31px; min-width: 70px; max-width: 190px" class="form-control" @change="updateStatusCakeValue(test, $event)">
                      <!--                    <option></option>-->
                      <option :value="row.status" :selected="checkStatusCake(test, row.status)" v-for="(row, index) in statusList" :key="index">
                        {{row.status}}
                      </option>
                      <!--                    <option :selected="(test.statusCake === undefined && (test.status === 'up' || test.status === 'down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
                      <!--                    <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
                      <!--                    <option :selected="(test.statusCake === undefined && test.status === 'paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
                      <!--                    <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
                      <!--                    <option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
                    </select>
                  </td>
                  <td width="2%">
                    <template>
                    <span v-if="test.acknowledgedBy" class="badge badge-pill badge-success">
												{{test.acknowledgedBy}}
                    </span>
                      <template v-else-if="test.status === 'down'">
                        <button @click="acknowledge(test)" v-if="group.downCount === 1" :disabled="selectedMonitorLoading && selectedMonitorLoading === test.id" type="button" class="btn btn-primary btn-sm">
                        <span v-if="selectedMonitorLoading && selectedMonitorLoading === test.id">
                          <div class="loader mini_loader"></div>
                        </span>
                          <span v-else>
                          Check In
                        </span>
                        </button>
                        <!--                      <button v-if="group.downCount === 1" type="button" class="btn btn-primary btn-sm">-->
                        <!--                        Check in-->
                        <!--                      </button>-->
                        <span v-else class="badge badge-pill badge-danger">
												Pending
                      </span>

                      </template>

                    </template>
                    <!--                  <template v-if="group.tests[0].acknowledgedBy">-->
                    <!--                    <span class="badge badge-pill badge-success">-->
                    <!--												{{ group.tests[0].acknowledgedBy }}-->
                    <!--											</span>-->
                    <!--                  </template>-->
                    <!--                  <button @click="acknowledge(group.tests[0])" v-else-if="group.tests[0].status === 'down'" :disabled="selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id" type="button" class="btn btn-primary btn-sm">-->
                    <!--                    <span v-if="selectedMonitorLoading && selectedMonitorLoading === group.tests[0].id">-->
                    <!--                      <div class="loader mini_loader"></div>-->
                    <!--                    </span>-->
                    <!--                    <span v-else>-->
                    <!--                      Check In-->
                    <!--                    </span>-->
                    <!--                  </button>-->
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </template>

        </div>
      <div class="row mt-2" v-if="getWPOGroup.length > 0 && tableType !== 'suspended'">
        <div class="col-md-12 text-center">
                    <span class="lh-3 pull-left">
                        Page {{this.pageNumber + 1}} of {{pageCount}}
                    </span>
          <section class="dataTables_paginate paging_full_numbers">
            <paginate
                :pageCount="pageCount"
                :clickHandler="goToPage"
                :prevText="'Prev'"
                :nextText="'Next'"
                page-class="page-item"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
                page-link-class="page-link"
                containerClass="pagination">
            </paginate>
          </section>
        </div>
      </div>
      <div class="customer-list-info" v-if="getWPOGroup.length === 0 && tableType !== 'suspended'">
        <div class="card-text text-center text-danger mb-3 font-weight-bold">
          No {{(status === 'Up') ? 'Recent' : 'Current'}} Outages Exists!
        </div>
      </div>
    </section>
    <affected-nodes-and-racks ref="nodes"/>


  </div>
</template>

<script>
import _ from "lodash";
import dateMixin from '../../../mixins/dateMixin'
import loginAsMixin from "../../../mixins/loginAsMixin";
import statisticsMixin from "../../../mixins/statisticsMixin";
import AdminLogs from "@/mixins/adminLogs";
import moment from "moment";
import swal from "sweetalert2";
import {db} from "@/firebase/init";
import Paginate from 'vuejs-paginate'
import md5 from "crypto-js/md5";
import axios from "axios";
import plan from "@/store/modules/plan";



export default {
  name: "BetterUptimeTable",
  props: ["datatableId", "status" , 'searchQuery', 'presetMacros', 'tableType'],
  mixins: [dateMixin, loginAsMixin, statisticsMixin, AdminLogs],
  components: {Paginate,
    affectedNodesAndRacks: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/affectedNodesAndRacks"),
    },

  data() {
    return {
      selectedFilters: [{ tag: 'all', text: 'All Tags'},
        { tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png') },
        { tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png') },
        { tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png') },
        { tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png') },
        { tag: 'squarespace',category: 'host', src: require('@/assets/img/squarespace.png') },
        { tag: 'nerdpress',category: 'cfe', src: require('@/assets/img/nerdpress.png') },
        { tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png') },
        { tag: 'wix', category: 'host', src: require('@/assets/img/wix.png') },
        { tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg') },
        { tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png') },
        { tag: 'none', text: 'No Tags'}
        ],
      allFilterSelected: false,
      notInWPOFilter: true,
      filteredOptions: [
        { tag: 'all', text: 'All Tags'},
        { tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png') },
        { tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png') },
        { tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png') },
        { tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png') },
        { tag: 'squarespace',category: 'host', src: require('@/assets/img/squarespace.png') },
        { tag: 'nerdpress',category: 'cfe', src: require('@/assets/img/nerdpress.png') },
        { tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png') },
        { tag: 'wix', category: 'host', src: require('@/assets/img/wix.png') },
        { tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg') },
        { tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png') },
        { tag: 'none', text: 'No Tags'},
      ],
      tracker: {},
      affectedNodes: [],
      affectedRacks: [],
      openedGroups: [],
      loading: false,
      tests: [],
      testGroups:[],
      domainDateTime: {},
      totalDownTests: 0,
      totalPausedTests: 0,
      totalPendingTests: 0,
      totalSuspendedTests: 0,
      allNodes: {},
      planSortType: null,
      ipSortType: null,
      outageSortType: null,
      nodeSortType: null,
      rackSortType: null,
      pageNumber: 0,
      updateItem: null,
      action: null,
      pageSize: 10,
      removeItem: null,
      statusSortType: 'asc',
      downtimeType: null,
      statusList: [],
      selectedMonitorLoading: null,
      selectedPlanLoading: null,
      causeLength: 33,
      activeJobsDomainList: [],
      activeMigrationList: [],
      completedJobsDomainList: [],
      pendingJobListener : null,
      completeJobListener : null,
      migrationListener : null,
    }
  },
  mounted(){
    this.pendingJobs();
    this.activeMigrations();
    this.completedJobs();
    this.getStatusList()
    this.getAllNodes();
  },
  computed:{
    user() {
      return this.$store.getters.user;
    },
    pageCount(){
      let filteredGroups = this.paginatedGroups.filter(el => el.planName!=='(N/A)' && el.planName!=='Suspended')
      let l = filteredGroups.length, s = this.pageSize;
      return Math.ceil(l/s);
    },
    getNonWPOGroup(){
      return this.paginatedGroups.filter(el => el.planName==='(N/A)')
    },
    getSuspendedGroup(){
      return this.paginatedGroups.filter(el => {
        if (el.planName==='Suspended') {
          el.showTests = true;
          return true
        }
      })
    },
    getWPOGroup(){
      console.log('a', this.paginatedGroups)
      // el.planName!=='(N/A)' &&
      let array= this.paginatedGroups.filter(el => el.planName!=='Suspended')
      console.log('array', array)
      if(this.planSortType === 'asc'){
        console.log('in type')
        array.sort((a, b) => {
          if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
            return 1
          }
          if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
            return -1
          }
          return 0
        });
      } else if(this.planSortType === 'desc'){
        array.sort(function(a, b){
          if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
            return 1
          }
          if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
            return -1
          }
          return 0
        });
      }
      if(this.nodeSortType === 'asc'){
        console.log('in node sort')
        array.sort((a, b) => {
          if (a.nodeName.toLowerCase() > b.nodeName.toLowerCase()) {
            return 1
          }
          if (a.nodeName.toLowerCase() < b.nodeName.toLowerCase()) {
            return -1
          }
          return 0
        });
      } else if(this.nodeSortType === 'desc'){
        array.sort(function(a, b){
          if (a.nodeName.toLowerCase() < b.nodeName.toLowerCase()) {
            return 1
          }
          if (a.nodeName.toLowerCase() > b.nodeName.toLowerCase()) {
            return -1
          }
          return 0
        });
      }
      if(this.rackSortType === 'asc'){
        console.log('in rack sort')
        array.sort((a, b) => {
          if (a.rackName.toLowerCase() > b.rackName.toLowerCase()) {
            return 1
          }
          if (a.rackName.toLowerCase() < b.rackName.toLowerCase()) {
            return -1
          }
          return 0
        });
      } else if(this.rackSortType === 'desc'){
        array.sort(function(a, b){
          if (a.rackName.toLowerCase() < b.rackName.toLowerCase()) {
            return 1
          }
          if (a.rackName.toLowerCase() > b.rackName.toLowerCase()) {
            return -1
          }
          return 0
        });
      }
      if(this.ipSortType === 'asc'){
        array.sort((a, b) => {
          if (a.serverIP > b.serverIP) {
            return 1
          }
          if (a.serverIP < b.serverIP) {
            return -1
          }
          return 0
        });
      } else if(this.ipSortType === 'desc'){
        array.sort(function(a, b){
          if (a.serverIP < b.serverIP) {
            return 1
          }
          if (a.serverIP > b.serverIP) {
            return -1
          }
          return 0
        });
      }
      if(this.outageSortType === 'asc'){
        array.sort((a, b) => {
          if (a.downCounts > b.downCounts) {
            return 1
          }
          if (a.downCounts < b.downCounts) {
            return -1
          }
          return 0
        });
      } else if(this.outageSortType === 'desc'){
        array.sort(function(a, b){
          if (a.downCounts < b.downCounts) {
            return 1
          }
          if (a.downCounts > b.downCounts) {
            return -1
          }
          return 0
        });
      }
      if(this.statusSortType === 'asc'){
        array.sort((a, b) => {
          if (a.status > b.status) {
            return 1
          }
          if (a.status < b.status) {
            return -1
          }
          return 0
        });
      } else if(this.statusSortType === 'desc'){
        array.sort(function(a, b){
          if (a.status < b.status) {
            return 1
          }
          if (a.status > b.status) {
            return -1
          }
          return 0
        });
      }
      if(this.downtimeType === 'asc'){
        array.sort((a, b) => {
            return a.tests[0].incidents[a.tests[0].incidents.length-1].start.localeCompare(b.tests[0].incidents[b.tests[0].incidents.length-1].start);
        });
      } else if(this.downtimeType === 'desc'){
        array.sort((a, b) => {
            return b.tests[0].incidents[b.tests[0].incidents.length-1].start.localeCompare(a.tests[0].incidents[a.tests[0].incidents.length-1].start);
        });
      }

      if (!this.planSortType && !this.statusSortType && !this.ipSortType && !this.rackSortType && !this.nodeSortType && !this.outageSortType) {
        array.sort(function(a, b){
          // ASC  -> a.length - b.length
          // DESC -> b.length - a.length
          return b.tests.length - a.tests.length;
        });
      }
      const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
      return array.slice(start, end);
    },
    paginatedGroups(){
      let filteredGroups = this.testGroups;
      if(this.searchQuery) {
        filteredGroups = filteredGroups.filter(g => {
          try{
            if(g.planName && typeof g.planName === "string" && g.planName.toLowerCase().includes(this.searchQuery)){
              return true;
            }
            let isTestInclude = false;
            g.tests.map(t => {
              if(t.url.toLowerCase().includes(this.searchQuery)){
                isTestInclude = true;
              }
            });
            return isTestInclude;
          }
          catch(e){
            console.log(e.toString() , 'This here', g.planName)
          }
        })
      } else if(this.selectedFilters.length || this.notInWPOFilter || (this.selectedFilters.length && this.notInWPOFilter)) {
        filteredGroups = filteredGroups.filter(g => {
          let isTestInclude = false
          if (this.notInWPOFilter && g.notInWPO) {
            isTestInclude = true;
          } else {
            g.tests.map(el => {
              // find if all is selected
              const isAllSelected = this.selectedFilters.find(el => el.tag === 'all');
              // find if none is selected
              const isNoneSelected = this.selectedFilters.find(el => el.tag === 'none' && !g.notInWPO);
              if (isAllSelected) {
                // find if tag categories exist
                isTestInclude = el.tagCategories && el.tagCategories.length
              } if(isNoneSelected) {
                isTestInclude = !el.tagCategories || el.tagCategories && !el.tagCategories.length
              } if(this.selectedFilters && this.selectedFilters.length) {
                const result = (el.tagCategories && el.tagCategories.length ? el.tagCategories.every(t => {
                  return this.selectedFilters.find(tag => t.tag.toLowerCase() === tag.tag && t.category.toLowerCase() === tag.category)
                }) : false) || false
                if(result) {
                  isTestInclude = true
                }
                // console.log('result', result)
                // this.selectedFilters.map(tag => {
                //   const obj = el.tagCategories && el.tagCategories.find(t => t.tag.toLowerCase() === tag.tag && t.category.toLowerCase() === tag.category);
                //   if (obj) {
                //     isTestInclude = true
                //   }
                // })
              }
            })
          }
          return isTestInclude;
        })
      }
      console.log('groups', filteredGroups)
      return filteredGroups
    },
  },
  watch: {
    paginatedGroups() {
      this.pageNumber = 0;
      this.pageSize= 10
    }
  },
  created(){
    if(this.status !== 'Up'){
      setInterval(() => this.startClockTicking(), 1000);
    }
  },
  methods: {
    getActiveJobTitle (test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      const domain = this.showDomainName(test.url)
      if (test.taskResolvedAt) {
        const dateObject = new Date(test.taskResolvedAt);

        // Get current time
        const currentTime = new Date();

        // Calculate the time difference in milliseconds
        const timeDifference = currentTime - dateObject;

        // Convert time difference to hours
        const minutesDifference = timeDifference / (1000 * 60);
        if (minutesDifference <= 60) {
          return `Possible DNS propagation or SSL issue. Site was added ${Math.ceil(minutesDifference)} minutes ago.`
        }
      }
      const activeM = this.activeMigrationList.find(el => el.domain === domain)
      if (activeM) {
        return 'Active migration request exists in WPO.'
      }
      const activeJob = this.activeJobsDomainList.find(el => (el.jobName !== 'set-php-version' && el.jobData.ip === test.serverIP))
      if (activeJob) {
        switch (activeJob.jobName) {
          case 'backup-job':
            return activeJob.operation === 'create' ? 'Active Backup CREATE process running' : 'Active Backup RESTORE process running'
          case 'staging-job':
            return 'Active STAGING job running'
          case 'cloning':
            return 'Active CLONE job running'
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${activeJob.jobData.phpVersion} from ${activeJob.jobData.prevPhpVersion} - ${moment(new Date(activeJob.createdAt)).fromNow()}.`
          default:
            return ''
        }
      }
    },
    getPhpJobTitle (test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      const domain = this.showDomainName(test.url)
      const activeJob = this.activeJobsDomainList.find(el => (el.jobName === 'set-php-version' && el.domain === domain))
      if (activeJob) {
        switch (activeJob.jobName) {
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${activeJob.jobData.phpVersion} from ${activeJob.jobData.prevPhpVersion} - ${moment(new Date(activeJob.createdAt)).fromNow()}.`
          default:
            return ''
        }
      } else {
        const lastIncident = test.incidents[test.incidents.length - 1]
        if (!lastIncident.start) {
          return
        }
        const date = lastIncident.start
        let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
        const obj1 = this.completedJobsDomainList.find(el => {
          return el.jobName === 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate60Min) && (el.domain === domain)
        })
        if (obj1) {
          return `Potential PHP version conflict. PHP Version was updated to ${obj1.jobData.phpVersion} from ${obj1.jobData.prevPhpVersion} - ${moment(new Date(obj1.createdAt)).fromNow()}.`
        }
      }
    },
    getCompletedJobTitle (test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      let domain = this.showDomainName(test.url);
      const lastIncident = test.incidents[test.incidents.length - 1]
      if (!lastIncident.start) {
        return
      }
      const date = lastIncident.start
      let earlierDate = new Date(new Date(lastIncident.start).getTime() - (30 * 60 * 1000)).toISOString();
      let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
      const job = this.completedJobsDomainList.find(el => {
        return el.jobName !== 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate) && (el.jobData.ip === test.serverIP)
      })
      if (job) {
        switch (job.jobName) {
          case 'backup-job':
            return job.operation === 'create' ? 'Backup CREATE process was running' : 'Backup RESTORE process was running'
          case 'staging-job':
            return 'STAGING job was running'
          case 'cloning':
            return 'CLONE job was running'
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${job.jobData.phpVersion} from ${job.jobData.prevPhpVersion} - ${moment(new Date(job.createdAt)).fromNow()}.`
          default:
            return ''
        }
      }
    },
    checkActiveJob (test) {
      let domain = this.showDomainName(test.url);
      if (test.taskResolvedAt) {
        const dateObject = new Date(test.taskResolvedAt);

        // Get current time
        const currentTime = new Date();

        // Calculate the time difference in milliseconds
        const timeDifference = currentTime - dateObject;

        // Convert time difference to hours
        const minutesDifference = timeDifference / (1000 * 60);
        if (minutesDifference <= 60) {
          return true
        }
      }
      return this.activeMigrationList.find(el => el.domain === domain) || this.activeJobsDomainList.find(el => (el.jobName !== 'set-php-version' && el.jobData.ip === test.serverIP))
    },
    checkPhpJob (test) {
      let domain = this.showDomainName(test.url);
      const obj = this.activeJobsDomainList.find(el => (el.jobName === 'set-php-version' && el.domain === domain))
      if (obj) {
        return true
      } else {
        const lastIncident = test.incidents[test.incidents.length - 1]
        if (!lastIncident.start) {
          return
        }
        const date = lastIncident.start
        let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
        const obj1 = this.completedJobsDomainList.find(el => {
          return el.jobName === 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate60Min) && (el.domain === domain)
        })
        return !!obj1
      }
    },
    checkCompletedJob (test) {
      const lastIncident = test.incidents[test.incidents.length - 1]
      if (!lastIncident.start) {
        return
      }
      const date = lastIncident.start
      let earlierDate = new Date(new Date(lastIncident.start).getTime() - (30 * 60 * 1000)).toISOString();
      let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
      let domain = this.showDomainName(test.url);
      const obj = this.completedJobsDomainList.find(el => {
        return el.jobName !== 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate) && (el.jobData.ip === test.serverIP)
      })
      return !!obj
    },
    pendingJobs(){
      const allowedOperations = ['create', 'restore']
      const query = db.collection('jobLogs')
          .where('status', '==', 'running')
          .where('jobName', 'in', ['backup-job', 'staging-job', 'cloning', 'set-php-version'])
          .orderBy("createdAt", "desc");

      this.pendingJobListener =  query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.activeJobsDomainList.push({
                jobName: data.jobName,
                domain: data.inputDomain,
                operation: data.jobData.operation || '',
                jobData: data.jobData
              })
            }
          } else if (change.type === 'removed') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.activeJobsDomainList =  this.activeJobsDomainList.filter(d=> {
                return !(d.domain === data.inputDomain && d.jobName === data.jobName)
              })
            }
          }
        })
      });
    },
    activeMigrations () {
      const allowedStatus = ['pending']
      let ref = db
          .collection("savedMigrations")
          .where('status', 'in', allowedStatus)

      this.migrationListener =  ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            this.activeMigrationList.push({
              domain: data.siteDetails.domainName,
              status: data.status || '',
            })
          } else if (change.type === 'removed') {
            this.activeMigrationList =  this.activeMigrationList.filter(d=> {
              return !(d.domain === data.siteDetails.domainName)
            })
          }
        })
      });
    },
    completedJobs(){
      let date = new Date()
      date.setDate(date.getDate() - 1);
      const allowedOperations = ['create', 'restore']
      const query = db.collection('jobLogs')
          .where('status', '==', 'complete')
          .where('jobName', 'in', ['backup-job', 'staging-job', 'cloning', 'set-php-version'])
          .where('createdAt', ">=", date.toISOString())
          .orderBy("createdAt", "desc");

      this.completeJobListener =  query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.completedJobsDomainList.push({
                jobName: data.jobName,
                domain: data.inputDomain,
                operation: data.jobData.operation || '',
                createdAt: data.createdAt,
                jobData: data.jobData
              })
            }
          } else if (change.type === 'removed') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.completedJobsDomainList =  this.completedJobsDomainList.filter(d=> {
                return !(d.domain === data.inputDomain && d.jobName === data.jobName)
              })
            }
          }
        })
      });
    },
    checkOption (event) {
      console.log(event)
      const { tag } = event.target._value;
      if (tag === 'all') {
        // check all tags
        if(this.selectedFilters && this.selectedFilters.length) {
          this.selectedFilters = []
          this.notInWPOFilter = false;
        } else {
          this.notInWPOFilter = true
          this.selectedFilters = this.filteredOptions.slice(1,-1)
        }
        console.log('selected filters',this.selectedFilters)
      }
      // else if(tag === 'none') {
      //   this.selectedFilters = []
      //   this.selectedFilters.push(this.filteredOptions[this.filteredOptions.length - 1])
      // } else {
      //   // remove all and none from array
      //   const index = this.selectedFilters.findIndex(el => el.tag === 'all' )
      //   if (index !== -1) {
      //     this.selectedFilters.splice(index, 1)
      //   }
      //   const noneIndex = this.selectedFilters.findIndex(el => el.tag === 'none' )
      //   if (noneIndex !== -1) {
      //     this.selectedFilters.splice(noneIndex, 1)
      //   }
      // }

    },
    changeCauseLength(test){
      this.$set(this.tracker, test.id, !this.tracker[test.id]);
      // if(this.tracker[test]){
      // }
      // else{
      //   this.$set(this.tracker, test.id, true);
      // }
      console.log('trackers', this.tracker)
    },
    getProperty(property) {
      return this.tracker[property] || false;
    },
    showDomainName (url) {
      const domainName = url.replace('https://', '').replace('/?v={timestamp}', '');
      // if (domainName.length > 22) {
      //   return [domainName.slice(0,22), domainName.slice(22,domainName.length)]
      // }
      return domainName

    },
    checkDownTime (test) {
      return (new Date() - new Date(test.incidents[test.incidents.length - 1].start))/60000
    },
    getScreenshotUrl (test) {
      return test.incidents[test.incidents.length - 1].screenshotUrl;
    },
    getEffectiveUrl (test) {
      return test.incidents[test.incidents.length - 1].effective_url || test.url;
    },
    getResponseUrl (test) {
      return test.incidents[test.incidents.length - 1].responseUrl || '';
    },
    getAcknowledgeBy (test) {
      if (test.incidents && test.incidents.length) {
        return test.incidents[test.incidents.length-1].acknowledgedBy || ''
        // const incidents = JSON.parse(JSON.stringify(test.incidents))
        // const obj = incidents.reverse().find(inc => !!inc.id);
        // if (obj && obj.acknowledgedBy) {
        //   return obj.acknowledgedBy
        // }
      }
      return false
    },
    async saveInDBAndShowSuccess(test, ack_by, noTicket) {
      // test.incidents[test.incidents.length - 1].acknowledgedBy = ack_by
      // const incidentId = test.incidents[test.incidents.length - 1].id
      // if (!incidentId) {
        // await db.collection('monitors').doc(test.id).update({
        //   incidents: test.incidents,
        //   lastAckBy: ack_by,
        //   LastAckAt: new Date().toISOString()
        // })
      // }

      this.selectedMonitorLoading= null
      if(!noTicket){
        swal({
          title: 'Success!',
          text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
          type: 'success',
          showCancelButton: true,
          confirmButtonColor: "#6ACF98",
          cancelButtonColor: "#EE8057",
          confirmButtonText: "Yes Proceed",
          cancelButtonText: "No Thanks",
        }).then((result) => {
          if(result.value) {
            this.openTicketModal(test, 'checkin')
          }
        })
      }
    },
    async bulkAcknowledgeV2(group, acknowledgedBy, noIncrement=null){
      try{
        const encryptedEmail =  this.user.email ?  md5(this.user.email.trim().toLowerCase()).toString() : '';
        const result  = await this.$http.post('/monitor/bulk-acknowledge',{
          grant_type: 'token',
        group,
        acknowledgedBy,
        noIncrement, encryptedEmail
      });
          swal({
            title: 'Success!',
            text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
            type: 'success',
            showCancelButton: true,
            confirmButtonColor: "#6ACF98",
            cancelButtonColor: "#EE8057",
            confirmButtonText: "Yes Proceed",
            cancelButtonText: "No Thanks",
          }).then((result) => {
            if(result.value) {
              this.openTicketModal(group.tests[0], 'checkin')
            }
          })
      }
      catch(e) {
        console.log('Error Occurred', e.toString())
      }
    },
    async bulkAcknowledge( group, acknowledgedBy, noIncrement){
      try {
        const firstCheckin = !group.tests.find(el => {
          return el.incidents[el.incidents.length - 1].acknowledgedBy
        });
        this.selectedPlanLoading= group.planName
        for(const row of group.tests){
          const lastObj = row.incidents[row.incidents.length - 1]
          if(!lastObj.acknowledgedBy && lastObj.status === 'down'){
            console.log('monitor to be processed', row.id)
            await this.acknowledge(row, acknowledgedBy, true)
          }
        }
        if (!noIncrement) {
          try{
            await this.incrementCountBasedOnType(this.user, 'monitor')
            const data= {
              ticketId: group.uid,
              taskId:  group.uid,
              type  : 'info',
              message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${group.uid}.`,
              actionType: 'monitor',
              customer: {
                domain: group.uid,
              }
            }
            // await this.addToAdminActiveTask({...data})
            await this.addRecentActivity({...data})
          }catch (e) {
            console.log('line 1016', e.toString())
          }
        }
        if(firstCheckin){
          console.log('firstCheckin')
          swal({
            title: 'Success!',
            text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
            type: 'success',
            showCancelButton: true,
            confirmButtonColor: "#6ACF98",
            cancelButtonColor: "#EE8057",
            confirmButtonText: "Yes Proceed",
            cancelButtonText: "No Thanks",
          }).then((result) => {
            if(result.value) {
              this.openTicketModal(group.tests[0], 'checkin')
            }
          })
        }
        this.selectedPlanLoading= null
      }catch (e) {
        this.selectedPlanLoading= null
        console.log('error while acknowledging', e.toString())
      }
    },
    async acknowledge(test, acknowledgedBy, noTicket) {
      // const incidents = JSON.parse(JSON.stringify(test.incidents))
      // const obj = incidents.reverse().find(inc => !!inc.id);
      let incidentId= test.incidents[test.incidents.length-1].id || ''
      const acknowledgedByName= acknowledgedBy ? acknowledgedBy : !noTicket ? this.user.firstName + ' ' + this.user.lastName : ''
      try{
        this.selectedMonitorLoading= test.id
        // save acknowledged by in db
        if (acknowledgedByName) {
          test.incidents[test.incidents.length - 1].acknowledgedBy = acknowledgedByName;
          await db.collection('monitors').doc(test.id).update({
            incidents: test.incidents
          })
        }
        // if(!obj) {
        //   swal({
        //     title: "Error!",
        //     text: 'No incident id exists!',
        //     type: "error",
        //     confirmButtonText: "Try Again!",
        //     confirmButtonColor: "#EE8057"
        //   });
        //   return false
        // }
        if(incidentId && acknowledgedByName && !noTicket){
          await this.$http.post("monitor/acknowledge/incident", {
            grant_type: "token",
            token: this.userToken,
            incidentId: incidentId,
            acknowledgedBy: acknowledgedByName
          })
          if(!noTicket) {
            try{
              await this.incrementCountBasedOnType(this.user, 'monitor')
              try {
                const data= {
                  ticketId: test.id,
                  taskId:  test.id,
                  type  : 'info',
                  message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${test.name}.`,
                  actionType: 'monitor',
                  customer: {
                    domain: this.showDomainName(test.url),
                  }
                }
                // await this.addToAdminActiveTask({...data})
                await this.addRecentActivity({...data})
              } catch (e) {
                console.log('unable to save recent activity', e.toString())
              }

            }catch (e) {
              console.log('line 1063', e.toString())
            }
          }
        }
        if (acknowledgedByName) {
          await this.saveInDBAndShowSuccess(test, acknowledgedByName, noTicket)
        }
      }catch (err){
        let errorMessage = 'Something went wrong while acknowledging the monitor';
        if (!err || !err.response || err.response.status !== 409 ) {
          test.incidents[test.incidents.length -1].acknowledgedBy = ''
          await db.collection('monitors').doc(test.id).update({ incidents: test.incidents})
          if(!noTicket) {
            swal({
              title: "Error!",
              text: errorMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
          }
        }

      } finally {
        this.selectedMonitorLoading= null
      }

    },
    checkStatusCake (test, statusCake) {
      if ((test.status === 'up' || test.status === 'down') && statusCake.toLowerCase() === 'active') {
        return true
      } else if (!(test.status === 'up' || test.status === 'down')) {
        if (test.statusCake && test.statusCake.toLowerCase() === statusCake.toLowerCase()) {
          return true
        } else if (!test.statusCake && (test.status === 'up' || test.status === 'down') && statusCake.toLowerCase() === 'active') {
          return true
        } else if (!test.statusCake && test.status === 'paused' && statusCake.toLowerCase() === 'suspended') {
          return true
        } else if (!test.statusCake && test.status === 'pending' && statusCake.toLowerCase() === 'pending') {
          return true
        }
      }
      return false
    },
    async getStatusList(){
      this.statusList=[]
      const ref=await db.collection('permissions').doc('betteruptime-monitor-settings').get()
      if(ref.exists){
        this.statusList.push({status: 'Active'})
        this.statusList.push({status: 'Pending'})
        this.statusList=this.statusList.concat(ref.data().settings);
      }
    },
    async openTicketModal(group, from){
      await this.$parent.$refs.ticketModal.load(this.presetMacros, group, from)
    },
    openAffectedNodesAndRacksModal(type){
      this.$refs.nodes.load(type==='node' ? this.affectedNodes : this.affectedRacks, this.allNodes, type)
    },
    remove(test, group) {
      swal({
        title: "Are you sure?",
        text: `Are you sure you want to delete this test?`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
          .then(async result => {
            if (result.value){
              this.removeItem = test;
              this.action = 'remove';
              try{
                await this.$http.post("monitor/delete/test", {
                  grant_type: "token",
                  token: this.userToken,
                  testId: test.id
                })
              }catch (err){
                console.log(err.toString())
            }
            try{
                await db.collection('monitors').doc(test.id.toString()).delete();
                // await this.removeAdminActiveTask({taskId:test.id})
                await this.startGrouping();
                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Monitor test has been deleted, TestId: ${test.id}, Test Name: ${test.name}`,
                  level: "info"
                })
              if (group) {
                group.tests = group.tests.filter(t=> t.id !== test.id)
              }
              }catch(err){
                let responseMessage = err.response.data.message;
                if (err.response.status === 422) {
                  responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
                } else if (err.response.status === 401) {
                  responseMessage = "You need update token. Please Try Again!";
                  this.refreshToken();
                }
                swal({
                  title: "Something went wrong!",
                  html: responseMessage,
                  type: "error",
                  confirmButtonText: "Try Again!",
                  confirmButtonColor: "#EE8057"
                });
                this.addLog({
                  name: this.user.firstName + " " + this.user.lastName,
                  message: "Error delete monitor test. Message: " + responseMessage,
                  level: "danger"
                });
              } finally{
              this.action = null;
              this.removeItem = null;
            }
            }
          });
    },
    pause(test, pauseValue) {
      this.updateItem = test;
      this.action = 'update';
      this.$http.post("domain/update/monitor_test", {
        grant_type: "token",
        token: this.userToken,
        data: {
          testID: test.id,
          paused: pauseValue ==0 ? false: true
        }
      })
          .then(() => {
            if(pauseValue === 0) {
              console.log('Un - Pausing....');
              this.$http.post('/monitor/get_test', {
                grant_type: "token",
                token: this.userToken,
                testId: test.id,
              }).then(resp => {
                let testData = resp.data.test.data.attributes;
                console.log('testData', testData)
                if(!testData.ErrNo){
                  test.status = testData.status;
                  if(test.statusCake === 'Active'){
                    if(testData.paused){
                      test.statusCake = 'Other'
                    }
                    else if(test.status === 'pending'){
                      test.statusCake = '15Min'
                    }
                  }
                  if (testData.status !== 'paused') {
                    test.incidents[test.incidents.length - 1].end = new Date().toISOString();
                    test.incidents.push({
                      start: new Date().toISOString(),
                      status: testData.status,
                      statusCode: (testData.status === 'up') ? 200 : 0,
                    });
                  }
                  // test.upTime = testData.Uptime;
                  test.updatedAt = new Date().toISOString();
                  if (testData.status === 'down') {
                    test.downCount += 1;
                  }
                }
                console.log(test);
                db.collection('monitors').doc(test.id.toString()).update(test);

                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Monitor test has been unpaused, TestId: ${test.id}, Test Name: ${test.name}`,
                  level: "info"
                })
              });
            }else{
              console.log('Pausing....');
              db.collection('monitors').doc(test.id.toString()).update({ status: 'paused' });
            }
          })
          .catch((err) => {
            console.error(err);
            let responseMessage = err.response.data.message;
            if (err.response.status === 422) {
              responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
            } else if (err.response.status === 401) {
              responseMessage = "You need update token. Please Try Again!";
              this.refreshToken();
            }
            swal({
              title: "Something went wrong!",
              html: responseMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
            this.addLog({
              name: this.user.firstName + " " + this.user.lastName,
              message: "Error StatusCake pause. Message: " + responseMessage,
              level: "danger"
            });
          })
          .finally(() => {
            this.action = null;
            this.updateItem = null;
          });

    },
    updateStatusCakeValue(test, e){
      console.log(e.target.value);
      console.log(test);
      console.log('Adding status cake value in: ' + test.id);
      if(test.notes === undefined){
        test.notes = [];
      }
      test.notes.push({
        noteDate: new Date().toISOString(),
        note: e.target.value,
        noteAddedBy: this.user.firstName + ' ' + this.user.lastName
      });
      if (e.target.value.toLowerCase() === 'suspended') {
        test.note = 'Suspended'
      }
      test.statusCake = e.target.value;
      test.updatedAt = new Date().toISOString();
      db.collection('monitors').doc(test.id.toString())
          .update(test)
          .then(()=>{
            if(e.target.value.toLowerCase() === 'active') {
              const incidentId = test.incidents[test.incidents.length - 1].id;
              console.log('incidentId', incidentId)
              if (incidentId) {
                console.log('resolving incident')
                this.$http.post("monitor/resolve/incident", {
                  grant_type: "token",
                  token: this.userToken,
                  incidentId,
                  resolvedBy: `${this.user.firstName} ${this.user.lastName}`
                })
              }
              this.pause(test, 0);
            }else{
              this.pause(test, 1);
            }
          }).catch(() => {
        this.addLog({
          message: `Error in updating status cake value!`,
          level: "danger"
        })
        swal('Error', 'Error in updating status cake value!', 'error');
      });
    },
    clickedIpSort () {
      if (!this.ipSortType) {
        this.ipSortType = 'desc'
      } else if (this.ipSortType === 'desc') {
        this.ipSortType = 'asc'
      } else {
        this.ipSortType = null
      }
    },
    clickedDowntimeSort () {
      if (!this.downtimeType) {
        this.downtimeType = 'desc'
      } else if (this.downtimeType === 'desc') {
        this.downtimeType = 'asc'
      } else {
        this.downtimeType = null
      }
    },
    clickedOutageSort () {
      if (!this.outageSortType) {
        this.outageSortType = 'desc'
      } else if (this.outageSortType === 'desc') {
        this.outageSortType = 'asc'
      } else {
        this.outageSortType = null
      }
    },
    clickedRackSort () {
      if (!this.rackSortType) {
        this.rackSortType = 'desc'
      } else if (this.rackSortType === 'desc') {
        this.rackSortType = 'asc'
      } else {
        this.rackSortType = null
      }
    },
    clickedNodeSort () {
      if (!this.nodeSortType) {
        this.nodeSortType = 'desc'
      } else if (this.nodeSortType === 'desc') {
        this.nodeSortType = 'asc'
      } else {
        this.nodeSortType = null
      }
    },
    clickedPlanSort () {
      if (!this.planSortType) {
        this.planSortType = 'desc'
      } else if (this.planSortType === 'desc') {
        this.planSortType = 'asc'
      } else {
        this.planSortType = null
      }
    },
    clickedStatusSort () {
      if (!this.statusSortType) {
        this.statusSortType = 'desc'
      } else if (this.statusSortType === 'desc') {
        this.statusSortType = 'asc'
      } else {
        this.statusSortType = null
      }
    },
    nextPage(){
      this.pageNumber++;
    },
    prevPage(){
      this.pageNumber--;
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum-1;
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    getNoteTooltip(data){
      let tooltip=''
      if(data.noteAddedAt){
        tooltip+=moment(data.noteAddedAt).format("DD MMM, YYYY HH:mm:ss")
      }
      return tooltip
    },
    async getAllNodes(){
      try{
        let nodesResp=await  db.collection('nodes').get()
        this.allNodes= {}
        nodesResp.forEach( el => {
          this.allNodes[el.id] = el.data()
          // this.allNodes.push({id:el.id, ...el.data()})
        })
      }catch(e){
        console.log('error', e.toString())
      }
    },
    doCopy(item){
      this.$copyText(item).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      }, function (e) {
        console.log(e)
      });
    },
    async renderDatatable(group, type){
      group.showTests = !group.showTests
      if (type === 'openedGroups') {
        // let openedGroups = [];
        // if (localStorage.getItem('openedGroups')) {
        //   openedGroups = JSON.parse(localStorage.getItem('openedGroups'))
        // }
        if (group.showTests) {
          this.openedGroups.push(group.planName)
        } else {
          this.openedGroups.splice(this.openedGroups.indexOf(group.planName), 1)
        }
        // localStorage.setItem('openedGroups', JSON.stringify(openedGroups))
      }
      let self = this
      if(type=='ungrouped'){
        // $(`#${this.datatableId}-ungrouped`).DataTable().destroy();
        // setTimeout(function () {
        //   $(`#${self.datatableId}-ungrouped`).dataTable({
        //     // pagingType: "full_numbers",
        //     "bPaginate": false, //hide pagination
        //     "bFilter": false, //hide Search bar
        //     destroy: true,
        //     retrieve: true,
        //     deferRender: true,
        //     stateSave: true,
        //     "bInfo" : false,
        //     "ordering": false,
        //     // order: [[2, "asc"]],
        //     // 'columnDefs': [ {
        //     //   'targets': [0,1, -1,7], /* column index */
        //     //   'orderable': false, /* true or false */
        //     // }]
        //   });
        // }, 0)
      }
      // else{
      //   group.showTests = !group.showTests
      //   let id=group.planName==='(N/A)' ? `${this.datatableId}-unavailable` : `${this.datatableId}-${group.planName}`
      //   if(id.includes('.com')){
      //     id= id.split('.')[0]
      //   }
      //   if(group.showTests){
      //     if($.fn.DataTable.isDataTable( `#${id}`)){
      //       $(`#${id}`).DataTable().destroy()
      //
      //     }
      //     $(`#${id}`).dataTable({
      //       pagingType: "full_numbers",
      //       destroy: true,
      //       retrieve: true,
      //       deferRender: true,
      //       stateSave: true,
      //       "ordering": true,
      //       order: [[2, "asc"]],
      //       'columnDefs': [ {
      //         'targets': [0,1, -1,7], /* column index */
      //         'orderable': false, /* true or false */
      //       }]
      //     });
      //   }
      // }
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    getTotalOutages(group){
      return group.tests.reduce((a, b) => a + (b.downCount || 0), 0);
    },
    findUser(group){
      if (group.uid ) {
        // let customers = localStorage.getItem('customers') ? JSON.parse(localStorage.getItem('customers')) : [];
        // let user = find(customers, {'docID': uid});
        swal({
          title: group.firstName + ' ' + group.lastName,
          text: 'Would you like to login to this customer\'s WPO account',
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then( result => {
          if(result.value){
            this.goToNuxt(group.uid);
          }
        });
      } else {
        swal("Not Found!", 'Plan is not found in the WPO', 'error');
      }
    },
    openModal(test, el){
      if(el === 'viewEventsModal'){
        this.$parent.selectedItemForView = _.cloneDeep(test);
        this.$parent.eventsShowAll = false
        this.$parent.notesShowAll = false
        this.$parent.notesPageSize = 5
        this.$parent.notesPageNumber = 0
        this.$parent.pageNumber = 0
        this.$parent.pageSize = 5
        this.$parent.selectedItemForView.incidents.reverse();
        if(this.$parent.selectedItemForView.notes !== undefined){
          this.$parent.selectedItemForView.notes.reverse();
        }
        let durations = [];
        for(let event of this.$parent.selectedItemForView.incidents){
          if(event.status === 'down' && event.end !== undefined){
            let dur = this.timeDifferenceBetweenGivenDates(event.end, event.start);
            if(dur.split(':').length === 2){
              durations.push("00:" + dur);
            }else if(dur.split(':').length === 1){
              durations.push("00:00:" + dur);
            }else{
              durations.push(dur);
            }
          }
        }
        const totalDurations = moment.duration();
        durations.map(duration => {
          totalDurations.add(duration);
        });
        this.$parent.totalDownDurationOfSelectedItem = moment.utc(totalDurations.asMilliseconds()).format("HH:mm:ss");
      }else{
        this.$parent.selectedItemForView = test;
      }
      /* eslint-disable */
      $("#" + el).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
      /* eslint-enable */
    },
    startClockTicking(){
      for(let test of this.tests){
        this.domainDateTime[test.url] = this.timeDifferenceBetweenGivenDates(new Date().toISOString(), test.incidents[test.incidents.length-1].start);
        this.$forceUpdate();
      }
    },
    getAffectedNodes(array){
      this.affectedNodes=[]
      if(array.length>0){
        array.map(el => {
          if(el.nodeId && el.status!=='paused'){
            let obj=this.affectedNodes.find(row => row.id && row.id===el.nodeId)
            if(obj){
              obj.count++
            }
            else {
              this.affectedNodes.push({id: el.nodeId, count:1})
            }
          }
        })
      }
    },
    getAffectedRacks(array){
      this.affectedRacks=[]
      if(array.length>0){
        array.map(el => {
          if(el.rackId && el.status!=='paused'){
            let obj=this.affectedRacks.find(row => row.id && row.id===el.rackId)
            if(obj){
              obj.count++
            }
            else {
              this.affectedRacks.push({id: el.rackId, count:1, nodeId:el.nodeId || ''})
            }
          }
        })
      }
    },
    groupTestsInAPlan(tests){
      console.log("tests", tests)
      this.tests = _.cloneDeep(tests);
      const testIps = ['69.162.173.212', '23.29.145.209']
      this.tests = this.tests.filter(test => {
        return !testIps.includes(test.serverIP)
      })
      this.getPausedAndDownTests(_.cloneDeep(this.tests))
      this.getAffectedNodes(_.cloneDeep(this.tests))
      this.getAffectedRacks(_.cloneDeep(this.tests))
      this.startGrouping()
    },
    getPausedAndDownTests(tests){
      this.totalPausedTests=0
      this.totalDownTests=0
      this.totalPendingTests=0
      this.totalSuspendedTests=0
      tests.map(el => {
        if(el.status==='paused'){
          if (el.hbSuspended) {
            this.totalSuspendedTests++
          } else {
            this.totalPausedTests++
          }
        }
        else if(el.status==='down'){
          this.totalDownTests++
        }
        else if(el.status==='pending'){
          this.totalPendingTests++
        }
      })

    },
    getRackName(name){
      if(name){
        let rack=name
        if(rack.includes('rack')){
          return rack.split('rack')[1]
        }else if(rack.includes('Rack')){
          return rack.split('Rack')[1]
        }
        else{
          return name
        }
      }
    },
    startGrouping () {
      console.log(this.tests, 'after tests')
      // const openedGroups = localStorage.getItem('openedGroups') ? JSON.parse(localStorage.getItem('openedGroups')) : []
      this.testGroups=[]
      const testIps = ['69.162.173.212', '23.29.145.209']
      this.tests = this.tests.filter(test => {
        return !testIps.includes(test.serverIP)
      })
      this.tests.map(test => {
        // const domainOwner = this.findOwnerOfDomain(test);
        const planName = test.hbSuspended ? 'Suspended' : ((test.plan) ? test.plan : '');
        let group = this.testGroups.find(g => g.planName && g.planName === planName);
        test.acknowledgedBy= this.getAcknowledgeBy(test)
        test.showCause= false
        if(!group) {
          group = {
            notInWPO: test.plan ? false : true,
            planName:  planName,
            serverIP: test.serverIP || '',
            uid: test.uid,
            firstName: test.firstName,
            lastName: test.lastName,
            nodeName: (this.allNodes[`${test.nodeId}`]) ? this.allNodes[`${test.nodeId}`].nodeName || '' : '',
            rackName: (this.allNodes[`${test.nodeId}`]) ? this.getRackName(this.allNodes[`${test.nodeId}`].rack_name) || '' : '',
            tests: [test],
            showTests: this.openedGroups.includes(planName),
            downCount: (test.status === 'down') ? 1 : 0,
            pauseCount: (test.status === 'paused') ? 1 : 0,
            pendingCount: (test.status === 'pending') ? 1 : 0,
          };
          console.log('pushing')
          this.testGroups.push(group);
        } else if(group){
          const testExist = group.tests.find(t => (t.id === test.id));
          if(!testExist) {
            group.tests.push(test);
            if (test.status === 'down') {
              group.downCount += 1;
            } else if (test.status === 'paused') {
              group.pauseCount += 1;
            } else if (test.status === 'pending') {
              group.pendingCount += 1;
            }
          }else if(testExist && testExist.status !== test.status) {
            testExist.status = test.status;
            if(test.status === 'down'){
              group.pauseCount -= 1;
              group.downCount += 1;
            } else if (testExist.status === 'paused') {
              group.pauseCount += 1;
              group.downCount -= 1;
            }
          }
          group.tests.map(groupTest => {
            const groupTestIsExist = this.tests.find(t => t.id === groupTest.id);
            if(!groupTestIsExist){
              if(groupTest.status === 'down'){
                group.downCount -= 1;
              }else if(groupTest.status === 'paused') {
                group.pauseCount -= 1;
              }else if(groupTest.status === 'pending') {
                group.pendingCount -= 1;
              }
              group.tests = group.tests.filter(t => t.id !== groupTest.id);
            }
          })
        }
      });
      this.testGroups.map(g => {
        if(g.tests.length === 1) {
          const isLastTestExist = this.tests.find(t => t.id === g.tests[0].id);
          if(!isLastTestExist) {
            this.testGroups = this.testGroups.filter(g1 => g1.planName !== g.planName);
          }
          g.downCounts= g.tests[0].downCount
          if (g.tests[0].status === 'down' && !g.tests[0].acknowledgedBy) {
            g.showCheckin = true
          }
        }else{
          g.acknowledgedByNames = [];
          g.showCheckin = false;
          if (this.status === 'Down') {
            g.tests.map(el => {
              if (el.acknowledgedBy) {
                if(!g.acknowledgedByNames.includes(el.acknowledgedBy)) {
                  g.acknowledgedByNames.push(el.acknowledgedBy)
                }
              } else {
                if(el.status === 'down') {
                  g.showCheckin = true
                }
              }
            })
          }
          console.log('show checkin', g.showCheckin)
          if (g.showCheckin) {

            // check if any down monitor and checked in
            const obj = g.tests.find(el => {
              const isAcknowledged = el.incidents[el.incidents.length - 1].acknowledgedBy;
              return el.status === 'down' && isAcknowledged
            })
            if (obj) {
              // g.tests.map(el => {
              //   const obj1 = el.incidents[el.incidents.length - 1]
              //   if (!obj1.acknowledgedBy && obj1.status === 'down') {
              //   }
              // })
              // const lastAckBy = obj.incidents[obj.incidents.length - 1].acknowledgedBy
              // this.bulkAcknowledge(g, lastAckBy, true)
              g.showCheckin = false;
            }
            // bring down monitors on top
            g.tests = g.tests.sort((a, b) =>
                a.status.localeCompare(b.status));
            // const latestObject = g.tests.reduce((latest, current) => {
            //   if (latest.LastAckAt && current.LastAckAt) {
            //     const latestDate = new Date(latest.LastAckAt);
            //     const currentDate = new Date(current.LastAckAt);
            //     return currentDate > latestDate ? current : latest;
            //   } else {
            //     return current.LastAckAt ? current : latest
            //   }
            // });
            // if (latestObject.LastAckAt) {
            //   const specificDate = new Date(latestObject.LastAckAt);
            //   const currentDate = new Date();
            //
            //   const diff = (currentDate.getTime() - specificDate.getTime()) / (60 * 1000); // difference in milliseconds
            //   if (diff < 10) {
            //     g.acknowledgedBy = latestObject.acknowledgedBy || ''
            //     g.showCheckin = false
            //     this.bulkAcknowledge(g, latestObject.acknowledgedBy, true)
            //   }
            // }
          }
          // const obj= g.tests.find(el => el.acknowledgedBy)
          // if(obj){
          //   if(this.status === 'Down'){
          //     g.acknowledgedBy = obj.acknowledgedBy || ''
          //     this.bulkAcknowledge(g, g.acknowledgedBy)
          //   }
          // }
          g.downCounts= this.getTotalOutages(g)
          if (g.downCount === 1 && (g.planName !=='(N/A)' && g.planName !== 'Suspended') ) {
            // if downCount is 1 then expand the plan
            this.openedGroups.push(g.planName)
            g.showTests = this.openedGroups.includes(g.planName)
          }
        }
        g.status=g.tests.find(el => el.status==='down') ? 'down' : 'paused'

      });
      if(this.status !== 'up') {
        // this.testGroups.sort((group1, group2) => (group1.downCount < group2.downCount) ? 1 : -1);
        this.testGroups = _.orderBy(this.testGroups, ['downCount'], ['desc']);
      }
      this.loading = false
      console.log('groups', this.testGroups)
      this.renderDatatable({}, 'ungrouped')
    }
  },
  beforeDestroy() {
    if (this.pendingJobListener) {
      this.pendingJobListener()
    }
    if (this.migrationListener) {
      this.migrationListener()
    }
    if (this.completeJobListener) {
      this.completeJobListener()
    }
  }
}
</script>

<style scoped>
table{
  min-height: 120px!important;
  border-collapse: unset !important;
}

table td.domain {
  min-width: 100px; /* Adjust the minimum width as per your requirement */
  max-width: 0;
  text-overflow: revert;
}
.dropdown-toggle:after {
  display: none;
}
.sc-status {
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: inline-block;
}

.sc-status.down {
  background-color: #a51f1f;
}

.sc-status.up {
  background-color: #6aa529;
}

.sc-status.pause{
  background-color: #f29f3f;
}
.sc-status.pending{
  background-color: #66615B;
}

.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  width: 15px!important;
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}
.single-outage-table tr > th,td{
  padding: 4px 4px !important;
}
.single-outage-table tr > th{
  font-size: 12px !important;
  font-weight: 400 !important;
}
code{
  color: #007bff !important;
}
.eventsTable tbody tr td{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.notesTable tbody tr td{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.lh-3{
  line-height: 3;
}
.group-section{
  background: #f4f4f4;
}
.pagination{
  display: inline-flex !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.badge.p-4-4{
  padding: 3px 3px !important;
  border-radius: 0px;
}
.down-monitor-bg {
  background-color: #F9BFB3 !important;
}
.bg-light {
  background-color: rgba(251,198, 88, 0.1) !important;
}
.w-8 {
  width: 8%;
  height: 8%;
}
.w-6 {
  width: 6%;
  height: 6%;
}
.w-25 {
  width: 20% !important;
  height: 20% !important;
}
.fs-20 {
  font-size: 20px;
}

.settinds-btn, .settinds-btn:active, .settinds-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.settinds-btn:hover {
  background-color: black!important;
  color: white !important;
}
.filter-btn, .filter-btn:active, .filter-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.filter-btn:hover {
  background-color: black!important;
  color: white !important;
}
.table-responsive{
  padding-bottom: 50px !important;
}
</style>
